const template = document.createElement("template");

template.innerHTML = `
<style>
  :host{
    --ctl-font: var(--ctl-font-sans);
    --ctl-color-text: var(--ctl-color-text);
    --ctl-color-muted: var(--ctl-color-muted);
    --ctl-color-border: var(--ctl-color-border);
    --ctl-color-brand: var(--ctl-color-brand);

    display:block;
    font-family: var(--ctl-font);
  }

  button{
    all: unset;
    width: 100%;
    box-sizing: border-box;
    display:flex;
    align-items:center;
    gap: var(--ctl-space-2-5);
    padding: var(--ctl-space-2-5) var(--ctl-space-2-5);
    border-radius: var(--ctl-radius-10);
    cursor: pointer;
    color: var(--ctl-color-text);
  }

  button:hover{
    background: color-mix(in srgb, var(--ctl-color-brand) 6%, transparent);
  }

  button:focus-visible{
    outline: none;
    box-shadow: var(--ctl-shadow-focus);
  }

  .leading, .trailing{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    color: var(--ctl-color-muted);
  }

  .label{
    min-width: 0;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    font-size: var(--ctl-font-size-md);
    font-weight: var(--ctl-font-weight-semibold);
  }

  .desc{
    margin-top: var(--ctl-space-0-5);
    color: var(--ctl-color-muted);
    font-size: var(--ctl-font-size-sm);
    line-height: var(--ctl-leading-tight);
  }

  .text{
    min-width:0;
    display:flex;
    flex-direction: column;
  }

  :host([disabled]) button{
    opacity: var(--ctl-opacity-disabled);
    cursor: not-allowed;
  }
  :host([disabled]) button:hover{
    background: transparent;
  }
</style>

<button id="btn" type="button" role="menuitem">
  <span class="leading"><slot name="leading"></slot></span>
  <span class="text">
    <span class="label"><slot></slot></span>
    <span class="desc"><slot name="description"></slot></span>
  </span>
  <span class="trailing"><slot name="trailing"></slot></span>
</button>
`;

export class CtlMenuItem extends HTMLElement {
  static get observedAttributes(){ return ["value","disabled"]; }

  constructor(){
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));
    this._btn = this.shadowRoot.getElementById("btn");
  }

  connectedCallback(){
    if (!this.hasAttribute("value")) {
      // default value = text content (stable enough for dev; set explicit value in prod)
      const t = (this.textContent || "").trim();
      if (t) this.setAttribute("value", t);
    }
    this._sync();
  }

  attributeChangedCallback(name, oldValue, newValue){
    if (oldValue !== newValue) this._sync();
  }

  get value(){ return this.getAttribute("value") || ""; }
  set value(v){ this.setAttribute("value", String(v)); }

  get disabled(){ return this.hasAttribute("disabled"); }
  set disabled(v){ v ? this.setAttribute("disabled","") : this.removeAttribute("disabled"); }

  _sync(){
    this._btn.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }

  focus(){ this._btn.focus(); }

  // Allow native click on host to trigger button click
  click(){ this._btn.click(); }
}

customElements.define("ctl-menu-item", CtlMenuItem);
